<template>
    <div class="get my-5" id="get-in-touch">
        <h4 class="text-center">-------- Contact us</h4>
        <p>Get all our information and message us directly from here.</p>
        <SocialMedia />

        <div class="contact-card row p-3">
            <!-- <div class="col-md-6 col-12 d-flex flex-column">
                <h4>Send A Message</h4>
                <input class="mb-2 p-2" type="text" placeholder="Name" v-model="username">
                <input class="mb-2 p-2" type="number" placeholder="Number" name="" id="" v-model="number">
                <input class="mb-2 p-2" type="email" placeholder="Email" name="" id="" v-model="email">
                <textarea class="mb-2 p-2" v-model="message" placeholder="Your message"></textarea>
                <button @click="saveData()">Submit</button>
            </div> -->
            <div class="col-md-6 col-12">
                <img src="@/assets/Id.jpeg" alt="id" class="w-100">
            </div>
            <div class="col-md-6 col-12">
                <p class="c-link mt-3"> ----------- QUICK CONTACT</p>
                <h3>Have Questions? Get in Touch!</h3>
                <p>Our team is ready to provide clear, helpful answers to guide you.
                    Feel free to reach out and we'll respond promptly with the information you need.</p>
                <div>
                    <div>
                        <p class="mb-0 font-weight-bold">Have any questions?</p>
                        <p class="mb-1"><strong><a href="tel:+918494998677">+91 8494998677</a></strong></p>
                        <p><strong><a href="tel:+918197722297">+91 8197722297</a></strong></p>
                    </div>
                    <div>
                        <p class="mb-0 font-weight-bold">Write email</p>
                        <p><strong><a href="mailto:aacandco12@gmail.com">aacandco12@gmail.com</a></strong></p>
                    </div>
                    <div>
                        <p class="mb-0 font-weight-bold">Visit anytime</p>
                        <a href="https://maps.app.goo.gl/eePNpA9m6tBMD1JG7" target="_blank"><strong>72, 4th main, 7th
                                Cross St, opp. shiva temple, Vinayaka Layout, Battarahalli,
                                Bengaluru, Karnataka 560049</strong></a>

                    </div>
                </div>
            </div>

        </div>
        <TeamMembers />
        <div class="work-with-us my-4 p-md-5 p-2">
            <h2 class="text-white font-weight-bold mb-0">Want to work with us?</h2>
            <p>Meet our people. See our work. Join our team.</p>
            <p class="gmail-btn text-center"><a href="mailto:aacandco12@gmail.com"><button class="btn btn-light">Gmail
                        <img src="@/assets/icons/gmail.png" alt="gmail" height="20" class="ml-1"></button></a></p>
        </div>
    </div>
</template>

<script>
import SocialMedia from "./SocialMedia.vue";
import TeamMembers from "./TeamMembers.vue";
import { gapi } from "gapi-script";
export default {
    name: 'get-in-touch-Component',
    data() {
        return {
            username: "",
            number: "",
            email: "",
            message: "",

            spreadsheetId: "1ykZAeG2NapAG80OwuMROSgID7OjLQNaBamvbhACIgg4", // Replace with your Spreadsheet ID
            clientId: "743744564418-hvi5s9oeofchvl3g1t12q3dcfa5j598l.apps.googleusercontent.com", // Replace with your OAuth 2.0 Client ID
            apiKey: "AIzaSyD2t-li439fF_WqbD5yNW4tUzbZNeC9Gw0", // Replace with your API key
        }
    },
    methods: {
        async loadGapi() {
            return new Promise((resolve, reject) => {
                gapi.load("client:auth2", async () => {
                    try {
                        await gapi.client.init({
                            apiKey: this.apiKey,
                            clientId: this.clientId,
                            discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
                            scope: "https://www.googleapis.com/auth/spreadsheets",
                        });
                        resolve();
                    } catch (error) {
                        reject(error);
                    }
                });
            });
        },
        async saveData() {
            try {
                // Authenticate User
                await this.loadGapi();
                const GoogleAuth = gapi.auth2.getAuthInstance();
                await GoogleAuth.signIn();

                // Append Data to Sheet
                const values = [[this.username, this.email]];
                await gapi.client.sheets.spreadsheets.values.append({
                    spreadsheetId: this.spreadsheetId,
                    range: "Sheet1!A:B", // Adjust the range to fit your sheet structure
                    valueInputOption: "USER_ENTERED",
                    resource: { values },
                });

                alert("Data saved successfully!");
                this.username = "";
                this.email = "";
            } catch (error) {
                console.error("Error saving data:", error);
                alert("Failed to save data.");
            }
        },
    },
    components: {
        SocialMedia,
        TeamMembers
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact-card {
    background-color: #f7f7f7;
    border: 1px solid lightgray;
    box-shadow: 2px 10px 10px 2px #00000087
}

button,
textarea,
input {
    border-radius: 4px;
    border: .5px solid #0000006b;
}

.work-with-us {
    height: 600px;
    background-image: url("@/assets/join_us.png");
    background-position: center;
    background-size: cover;
}

.gmail-btn {
    /* position: inherit; */
    margin-top: 370px;
}

@media screen and (max-width: 480px) {
    .work-with-us {
        height: 300px;
    }

    .gmail-btn {
        /* position: inherit; */
        margin-top: 150px;
    }
}
</style>